export default "__VITE_ASSET__689a388a__"